import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function ChapterPicker({ chapters, current, onSelect, onClose }) {
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);
    return (
        <div className="fixed inset-0 z-50 animate-fade-in" data-testid="chapter-picker">
            <div className="absolute inset-0 bg-ink/40" onClick={onClose} />
            <div className="absolute inset-x-0 bottom-0 max-w-md mx-auto bg-white rounded-t-3xl shadow-[0_-8px_32px_rgba(30,43,38,0.15)] animate-sheet-in">
                <div className="px-6 py-4 border-b border-ink-10 flex items-center justify-between">
                    <div>
                        <div className="font-ui text-[11px] uppercase tracking-[0.2em] text-moss-deep">Gospel of</div>
                        <div className="scripture text-2xl text-ink">Matthew</div>
                    </div>
                    <button
                        data-testid="close-chapter-picker"
                        onClick={onClose}
                        className="w-9 h-9 rounded-full flex items-center justify-center hover:bg-ink-10 transition"
                        aria-label="Close chapter picker"
                    >
                        <X size={18} className="text-ink" />
                    </button>
                </div>
                <div className="p-5 max-h-[60vh] overflow-y-auto sheet-scroll">
                    <div className="grid grid-cols-5 gap-2">
                        {chapters.map((c) => (
                            <button
                                key={c.chapter}
                                data-testid={`chapter-btn-${c.chapter}`}
                                onClick={() => { onSelect(c.chapter); onClose(); }}
                                className={
                                    "aspect-square rounded-xl font-ui font-medium text-[15px] transition-all active:scale-95 " +
                                    (c.chapter === current
                                        ? "bg-moss text-white shadow-sm"
                                        : "bg-sage-paper text-ink hover:bg-moss/10 hover:text-moss-deep")
                                }
                            >
                                {c.chapter}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
